<template>
    <div>
        <div class="page-btns-box">
            <el-button
                v-if="$utils.have('/voice/save')"
                type="primary"
                icon="el-icon-plus"
                @click="$refs.voiceEdit.show()"
                size="small"
                >上传语音</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="语音包id" ></el-table-column>
                <el-table-column prop="name" label="语音名称"></el-table-column>
				<el-table-column prop="activityId" label="绑定演出id" ></el-table-column>
				<el-table-column prop="activityName" label="演出名称" min-width="180" show-overflow-tooltip></el-table-column>
				<el-table-column prop="time" label="语音时长" ></el-table-column>
				<el-table-column prop="playTime" label="播放次数"></el-table-column>                
                <el-table-column prop="createTime" label="上传时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/voice/detail')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
						<el-button
						    v-if="$utils.have('/voice/delete')"
						    type="text"
						    size="small"
						    icon="el-icon-delete"
						    @click="detele(scope.row.id)"
						    >删除</el-button
						>
						<el-button
							v-if="scope.row.fileUrl"
						    type="text"
						    size="small"
						    icon="el-icon-video-play"
						     @click="$player.play({playUrl:scope.row.fileUrl})"
						    >播放</el-button
						>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
		<voice-edit ref="voiceEdit" @onUpdate="getDataList()"></voice-edit>
        

    </div>
</template>

<script>
import voiceEdit from './components/voice-edit';
const defaultParams = {
    pageNo:1,
    
}
export default {
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                
            },
            listLoading: true,
            
        }
    },
	components:{
	    voiceEdit
	},
    computed:{
        
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.params = {
                ...this.params
            }
            this.listLoading = true;
            this.$request({
                url: "/voice/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
                   
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },       
        //编辑
        edit(id){
            this.$refs.voiceEdit.show(id)
        },
		//删除
		detele(id) {
		    this.$confirm('确认删除语音？', '提示', {
		        type: 'warning',
		        center: true,
		        closeOnClickModal: false
		    }).then(() => {
		        this.$request({
		            url: "/voice/delete",
		            method: "POST",
		            params: {id:id},
		        })
		        .then((res) => {
		        	const { state} = res.data;
		        	if ( state == 1 ) {
		        		this.$message.success("操作成功");
						this.getDataList()		               
		        	} else {		                
		        		this.$message.error("操作失败");
		        	}
		        })
		        
		    }).catch(() => { })
		},
       
    }
}
</script>